<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 *ngIf="!handset" translate>equipment.details.modals.assigned-user.title-equipment</h4>
        <h4 *ngIf="handset" translate>equipment.details.modals.assigned-user.title-handset</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close"></i>
        </button>
      </div>
      <div *ngIf="loading">
        <ngx-skeleton-loader [theme]="{'height':'200px'}"></ngx-skeleton-loader>
      </div>
      <form *ngIf="!loading">
        <div class="form-group">
          <label for="company" translate>equipment.details.modals.assigned-user.user-label</label>
          <div ngbDropdown class="vox-dropdown-input" placement="bottom">
            <button
              id="assign-user-dropdown"
              ngbDropdownToggle
              >
              <span *ngIf="!selectedUser" translate>equipment.details.modals.assigned-user.user-placeholder</span>
              <span *ngIf="selectedUser">{{selectedUser.firstName}} {{selectedUser.lastName}} ({{selectedUser.extension}})</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="assign-user-dropdown">
              <button ngbDropdownItem
              type="button"
              *ngFor="let user of users; let idx = index"
              (click)="onSelectUser(user)"
              translate>
              {{user.firstName}} {{user.lastName}} ({{user.extension}})
            </button>
            </div>
          </div>
        </div>
        <div class="submit-container">
          <button class="vox-btn vox-btn-primary" type="submit" [disabled]="!selectedUser" (click)="assignToUser()" [ladda]="loadingAssign" data-spinner-color="grey" data-style="zoom-in" >
            <span translate>equipment.details.modals.assigned-user.assign-button</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
